import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import * as Toastr from 'toastr'
import i18n from '../i18n/index'
import * as Sentry from '@sentry/browser'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        lang: null,
        firebaseToken: null,
        isMessagingSupported: false,
        toaster: {
            closeButton: false,
            debug: false,
            newestOnTop: true,
            progressBar: true,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
            onclick: null,
            showDuration: 300,
            hideDuration: 100,
            timeOut: 5000,
            extendedTimeOut: 1000,
            showEasing: 'swing',
            hideEasing: 'linear',
            showMethod: 'fadeIn',
            hideMethod: 'fadeOut'
        },
        vueAppBackendUrl: '',
        vueAppBaseUrl: '',
        vueAppMapboxAccessToken: '',
        vueAppBingKey: '',
        vueAppUrlSignaler: '',
        vueAppStandAlone: false
    },
    mutations: {
        setVueAppBackendUrl: function (state, vueAppBackendUrl) {
            state.vueAppBackendUrl = vueAppBackendUrl
        },
        setVueAppBaseUrl: function (state, vueAppBaseUrl) {
            state.vueAppBaseUrl = vueAppBaseUrl
        },
        setIsMessagingSupported: function (state, isMessagingSupported) {
            state.isMessagingSupported = isMessagingSupported
        },
        setLang(state, lang) {
            localStorage.setItem('lang', lang)
            state.lang = lang
        },
        setVueAppBingKey(state, vueAppBingKey) {
            state.vueAppBingKey = vueAppBingKey
        },
        setVueAppMapboxAccessToken(state, vueAppMapboxAccessToken) {
            state.vueAppMapboxAccessToken = vueAppMapboxAccessToken
        },
        setFirebaseToken(state, token) {
            localStorage.setItem('firebase', token)
            state.firebaseToken = token
        },
        setVueAppUrlSignaler(state, vueAppUrlSignaler) {
            state.vueAppUrlSignaler = vueAppUrlSignaler
        },
        setVueAppStandAlone(state, vueAppStandAlone) {
            state.vueAppStandAlone = vueAppStandAlone
        }
    },
    actions: {
        initialiseStore({ state }) {
            var lang = localStorage.getItem('lang')
            var user = localStorage.getItem('user')
            var token = localStorage.getItem('token')

            if (user && token) {
                state.auth.token = token
                state.auth.user = JSON.parse(user)
                state.auth.isConnected = true
            }

            if (lang) {
                state.lang = lang
            } else {
                state.lang = process.env.VUE_APP_I18N_LOCALE
            }
        },
        toast: (state, data) => {
            Toastr.options = state.toaster
            Toastr[data.type](data.message, data.title)
        },
        toastError: ({ dispatch }, error) => {
            let traduction = i18n.messages[process.env.VUE_APP_I18N_LOCALE]
            let title = traduction.error.title
            let message = traduction.error.default_message
            if (error.response && error.response.status) {
                switch (error.response.status) {
                    case 400:
                        if (
                            error.response.data.message ===
                            'auth.user.not-found'
                        ) {
                            title =
                                traduction.error.validation[
                                    'wrong_password_or_email'
                                ]
                            message =
                                traduction.error.validation['retry_password']
                        } else {
                            message.traduction.error.validation.request
                        }
                        break
                    case 401:
                        if (error.response.data.message) {
                            message = traduction.error.validation['access']
                        }
                        break
                    case 403:
                        if (
                            error.response.data.message ===
                            'Your email address is not verified.'
                        ) {
                            message =
                                traduction.error.validation.email_confirmed
                        } else if (
                            error.response.data.message ===
                            'error.missing_token'
                        ) {
                            message =
                                traduction.error.validation.notification.message
                            title =
                                traduction.error.validation.notification.title
                        } else {
                            message = traduction.error.validation['access']
                        }
                        if (error.response.data.error === 'Password mismatch') {
                            title =
                                traduction.error.validation[
                                    'wrong_password_or_email'
                                ]
                            message =
                                traduction.error.validation['retry_password']
                        }
                        break
                    case 409:
                        if (error.response.data.message === 'existing_email') {
                            title =
                                traduction.error.validation['existing_email']
                                    .title
                            message =
                                traduction.error.validation['existing_email']
                                    .message
                        } else {
                            message = traduction.error.default_message
                        }
                        break
                    case 422:
                        if (error.response.data.errors) {
                            const err = Object.values(
                                error.response.data.errors
                            )[0]
                            title = traduction.error.validation.title
                            message =
                                traduction.error.validation[
                                    err[0].split('.')[1]
                                ] +
                                ' : ' +
                                Object.keys(error.response.data.errors)[0]
                        } else {
                            message = traduction.error.validation.title
                        }
                        Sentry.withScope((scope) => {
                            scope.setExtra('code', '422')
                            Sentry.captureException(error)
                        })
                        break
                    case 429:
                        message = traduction.error.validation['too_many']
                        title = traduction.error.validation['auto_protection']
                        break

                    case 500:
                        if (error.response.data.message) {
                            title = traduction.error.title
                            message = traduction.error.default_message
                        }
                        Sentry.withScope((scope) => {
                            scope.setExtra('code', '500')
                            Sentry.captureException(error)
                        })
                        break
                }
            }

            dispatch('toast', {
                type: 'error',
                title: title,
                message: message
            })
        }
    },
    modules: modules
})
